import { render } from "./Purpose.vue?vue&type=template&id=f4656348&scoped=true&ts=true"
import script from "./Purpose.vue?vue&type=script&lang=ts"
export * from "./Purpose.vue?vue&type=script&lang=ts"

import "./Purpose.vue?vue&type=style&index=0&id=f4656348&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4656348"]])

export default __exports__